<div *ngIf="navData" class="data-wrap" fxLayout="column">
    <div class="title" fxLayoutAlign="start start" fxLayoutGap="5px">
        <mat-icon>{{ (navData.data.course | resourceCertificate).icon }}</mat-icon>
        <div i18n>Well Done!</div>
    </div>

    <ng-container *ngIf="navData.data.customDesc">
        <div class="desc">{{ navData.data.customDesc }}</div>
    </ng-container>
    <!-- <ng-container *ngIf="!navData.data.isLastItem && !navData.data.customDesc" [ngTemplateOutlet]="desc"></ng-container> -->
    <div class="desc" *ngIf="navData.data.isLastItem && !navData.data.customDesc" i18n>
        Do you want to mark this part as done ?
    </div>
    <div fxLayoutGap="20px" fxLayout="column" class="mt-1">
        <div
            *ngIf="navData.data.isLastItem"
            class="action"
            fxLayout="row-reverse"
            fxLayoutAlign="start center"
            fxLayoutGap="10px"
        >
            <button
                [disabled]="hideMain"
                fxFlex="0 0 auto"
                class="mobile-button pos-btn"
                (click)="userIsDone = true; hideMain = true"
                mat-button
                i18n
            >
                Yes I'm done
            </button>
            <button
                fxFlex="0 0 auto"
                class="mobile-button negative"
                [disabled]="hideMain"
                (click)="
                    onClose.emit({
                        data: {
                            type: navData.data.type,
                            response: TakeResActionValue.CANCEL
                        }
                    })
                "
                mat-button
                i18n
            >
                Close
            </button>
        </div>
        <ng-container *ngIf="userIsDone || !navData.data.isLastItem">
            <ng-container [ngTemplateOutlet]="desc"></ng-container>
            <div
                *ngIf="navData.data.course.user_collaboration?.signoff_required?.status"
                class="input-field-parent"
                fxLayout="column"
                fxLayoutGap="5px"
            >
                <mat-form-field cdkFocusInitial appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                    <textarea
                        #taskInput
                        matInput
                        type="text"
                        [formControl]="feedback"
                        placeholder="Write feedback to admin"
                        i18n-placeholder
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="4"
                        cdkAutosizeMaxRows="10"
                    ></textarea>
                </mat-form-field>
            </div>

            <div class="action" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button
                    [disabled]="hideSignoff"
                    fxFlex="0 0 auto"
                    class="mobile-button positive sign-btn"
                    (click)="onSignoff(); hideSignoff = true"
                    mat-button
                    i18n
                >
                    Signoff
                </button>
                <button
                    fxFlex="0 0 auto"
                    class="mobile-button custom"
                    (click)="
                        onClose.emit({
                            data: {
                                type: navData.data.type,
                                response: TakeResActionValue.CONTINUE_LATER
                            }
                        })
                    "
                    mat-button
                    i18n
                >
                    Continue later
                </button>
                <button
                    fxFlex="0 0 auto"
                    class="mobile-button negative"
                    (click)="
                        onClose.emit({
                            data: {
                                type: navData.data.type,
                                response: TakeResActionValue.CANCEL
                            }
                        })
                    "
                    mat-button
                    i18n
                >
                    Close
                </button>
            </div>
            <div *ngIf="showGroupWork" class="mt-1" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
                <div class="desc" i18n>Did you take this course by yourself or with a group?</div>
                <div class="action" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <button
                        [disabled]="hideGroupWork"
                        fxFlex="0 0 auto"
                        class="mobile-button positive"
                        (click)="onDone(); hideGroupWork = true"
                        mat-raised-button
                        i18n
                    >
                        By myself
                    </button>
                    <button
                        fxFlex="0 0 auto"
                        class="mobile-button negative"
                        [disabled]="hideGroupWork"
                        (click)="showGroups = true; hideGroupWork = true"
                        mat-button
                        i18n
                    >
                        With a group
                    </button>
                </div>
                <div class="w-100" *ngIf="showGroups" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
                    <app-user-search-chips-display
                        [user]="authUser"
                        (onUpdateSelectiedUsers)="participantUsers = $event"
                    ></app-user-search-chips-display>
                    <app-occasion-spend-time
                        label="Time spent for this groupwork"
                        i18n-label="@@spendTimeForThisGroupWork"
                        [occasion]="navData.data.occasion"
                        [formControl]="timeSpendControl"
                    ></app-occasion-spend-time>
                    <div class="action mt-1" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button
                            fxFlex="0 0 auto"
                            class="mobile-button positive"
                            [disabled]="hideDoneGroupWork"
                            (click)="submitWithGroup(); hideGroupWork = true; hideDoneGroupWork = true"
                            mat-raised-button
                            i18n
                        >
                            Done
                        </button>

                        <button
                            fxFlex="0 0 auto"
                            class="mobile-button negative"
                            [disabled]="hideDoneGroupWork"
                            (click)="onClose.emit(); hideGroupWork = false"
                            mat-button
                            i18n
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #desc>
    <div class="desc" *ngIf="navData.data.course.user_collaboration?.signoff_required?.status">
        <span i18n>
            Now you have completed all parts. You can signoff now and the admin will need to approve in order for you to
            download your PDF of
        </span>
        {{ (navData.data.course | resourceCertificate).certificate }}.
        <span i18n> Check status in the Activity overview. You can send a message to the admin below. </span>
    </div>
    <div class="desc" *ngIf="!navData.data.course.user_collaboration?.signoff_required?.status">
        <span i18n="@@youCompletedAllPartsSignOffNow">
            Now you have completed all parts. You can sign off now and you will be able to download your PDF of
        </span>
        {{ (navData.data.course | resourceCertificate).certificate }}.
    </div>
</ng-template>
